import { render, staticRenderFns } from "./TwoPhaseMethodSettingTOTP.vue?vue&type=template&id=7cc29e9e&scoped=true&"
import script from "./TwoPhaseMethodSettingTOTP.vue?vue&type=script&lang=js&"
export * from "./TwoPhaseMethodSettingTOTP.vue?vue&type=script&lang=js&"
import style0 from "./TwoPhaseMethodSettingTOTP.vue?vue&type=style&index=0&id=7cc29e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc29e9e",
  null
  
)

export default component.exports